import PropTypes from 'prop-types';

export default function OutlineTrash(props) {
    const { color = 'currentColor', size = 20, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M7.551 3.467a.816.816 0 0 1 .817-.816h3.266a.816.816 0 0 1 .816.816v.817H7.551v-.817Zm-1.633.817v-.817a2.45 2.45 0 0 1 2.45-2.45h3.266a2.45 2.45 0 0 1 2.45 2.45v.817h3.265a.816.816 0 1 1 0 1.633h-.816V16.53a2.45 2.45 0 0 1-2.45 2.45H5.918a2.45 2.45 0 0 1-2.45-2.45V5.917h-.816a.817.817 0 0 1 0-1.633h3.266Zm.817 1.633H14.9V16.53a.816.816 0 0 1-.817.817H5.918a.816.816 0 0 1-.816-.817V5.917h1.633Zm1.633 2.45a.816.816 0 0 1 .816.816v4.899a.816.816 0 0 1-1.633 0v-4.9a.816.816 0 0 1 .817-.816Zm4.082.816a.817.817 0 1 0-1.633 0v4.899a.817.817 0 0 0 1.633 0v-4.9Z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
}

OutlineTrash.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
